import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import StatusText from 'common/component/StatusText'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import colors from 'assets/theme/base/colors';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { getReorderDrag, getStaticLegal } from '../../../redux/slices/common';
import { useSelector } from 'react-redux';
import Loader from 'common/Loader';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import NoDataFound from 'common/component/NoDataFound';
import MDButton from 'components/MDButton';

const CareerDetail = ({ legalId, fullRoleTabSlug }) => {
  const { grey } = colors;
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const { singleLegal, isLoading } = useSelector((state => state.common));
  const [dragSection, setDragSection] = useState({
    customerExperienceSection: singleLegal?.customerExperienceSection?.section,
    testimonialsSection: singleLegal?.testimonialsSection?.members,
    jobOpeningsSection: singleLegal?.jobOpeningsSection?.section,

  });
  const [nodataFound, setNodataFound] = useState(false)
  const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);

  useEffect(() => {
    setDragSection({
      customerExperienceSection: singleLegal?.customerExperienceSection?.section,
      testimonialsSection: singleLegal?.testimonialsSection?.members,
      jobOpeningsSection: singleLegal?.jobOpeningsSection?.section,
    })
  }, [singleLegal])

  // ************************************************** Get Data **************************************************
  useEffect(() => {
    if (fullRoleTabheading) {
      dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then((res) => {
        setNodataFound(false)

      }).catch((err) => {
        setNodataFound(true)

      });
    }
  }, [fullRoleTabheading, fullRoleTab])


  const onDragEnd = (result, type) => {
    if (!result.destination) return;
    let items = [];

    items = Array.from(dragSection?.[type] || []);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const filteredData = items.map((item, index) => ({
      _id: item._id,
      order: index, // Reassign order based on position
    }));

    // ------------------------------------------api hit----------------------------------------------
    const payload = {
      "id": singleLegal?._id,
      "sectionType": type,
      sections: filteredData
    }
    dispatch(getReorderDrag(payload)).unwrap().then((res) => {
    }).catch((err) => {
    });
    // Update state to re-render the list
    setDragSection((prev) => ({
      ...prev,
      [type]: items,
    }));
  };

  return (
    <>
      {
        isLoading ?
          <Loader /> :
          <>
            {
              nodataFound ? <NoDataFound /> :
                <Box p={4} pt={2} className="static-pages-container">

                  {/***************** Page Title *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                      <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{fullRoleTabheading}</Typography>
                      <StatusText status={singleLegal?.status ? "active" : "inactive"} />
                    </Stack>
                  </Card>

                  {/***************** Selected Platforms ****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    {/* <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2}>
                <Typography variant='h5' fontWeight="semibold">Selected Platforms</Typography>
              </Stack>

              <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                <Grid item xs={12}>
                  <Stack direction="row" alignItems="center" spacing={3}>
                    {singleLegal?.platformAvailability?.hyperwolf && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>{"Hyperwolf"}</badge>}
                    {singleLegal?.platformAvailability?.hemp && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hemp</badge>}
                  </Stack>
                </Grid>
              </Grid> */}

                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                      <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                      <Grid item xs={12}>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          {singleLegal?.displaySettings?.footer && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>}
                          {singleLegal?.displaySettings?.hamburgerMenu && <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>}
                        </Stack>
                      </Grid>
                    </Grid>
                  </Card>

                  {/***************** Meta Tags *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
                    </Stack>

                    <Grid container alignItems="center" spacing={3} mb={2}>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title ? singleLegal?.metaProperties?.title : "-"}</Typography>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description ? singleLegal?.metaProperties?.description : "-"}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy ? singleLegal?.createdBy : "-"}</Typography>
                      </Grid>

                    </Grid>
                  </Card>

                  {/***************** Top Banner *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Header Section</Typography>
                      <StatusText status={singleLegal?.headerSection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.headerSection?.status &&
                      <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                          <Grid container spacing={3}>

                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Title(H1)</Typography>
                              <Typography variant='h5' fontWeight="medium">{singleLegal?.headerSection?.pageTitle ? singleLegal?.headerSection?.pageTitle : "-"}</Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                              <Typography
                                variant="h5"
                                fontWeight="medium"
                                dangerouslySetInnerHTML={{
                                  __html: singleLegal?.headerSection?.section?.description || "-",
                                }}
                              />
                            </Grid>

                            <Grid item xs={12}>
                              <Grid container spacing={3}>
                                <Grid item xs={12} md={6}>
                                  <Typography variant='body2' color={grey[600]} mb={1}>CTA</Typography>
                                  <Typography variant="h5" fontWeight="medium">
                                    {singleLegal?.headerSection?.section?.cta ?
                                      singleLegal?.headerSection?.section?.cta
                                      :
                                      "-"
                                    }
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Typography variant='body2' color={grey[600]} mb={1}>CTA Link</Typography>
                                  <Typography variant="h5" fontWeight="medium">
                                    {singleLegal?.headerSection?.section?.cta ? (
                                      <a
                                        href={singleLegal?.headerSection?.section?.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className='cta-link-btn'
                                      >
                                        {singleLegal?.headerSection?.section?.url}
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    }
                  </Card>

                  {/***************** Hero Banner *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">Hero Banner</Typography>
                      <StatusText status={singleLegal?.brandStorySection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.brandStorySection?.status &&

                      <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={6}>
                          <Stack direction="row" spacing={1.25}>
                            <img style={{ borderRadius: '20px', width: '450px', height: '450px', objectFit: 'cover' }} src={singleLegal?.brandStorySection?.section?.image?.url ? singleLegal?.brandStorySection?.section?.image?.url : defaultProductImage} alt="No Image Found" />
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Title(H3)</Typography>
                              <Typography variant='h5' fontWeight="medium">{singleLegal?.brandStorySection?.pageTitle ? singleLegal?.brandStorySection?.pageTitle : "-"}</Typography>
                            </Grid>

                            <Grid item xs={12}>
                              <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                              <Typography
                                variant="h5"
                                fontWeight="medium"
                                dangerouslySetInnerHTML={{
                                  __html: singleLegal?.brandStorySection?.section?.description || "-",
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    }

                  </Card>

                  {/***************** Alternating Content Showcase: Customer Experience Section *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">{'Alternating Content Showcase'}  <span className='drag_drop'>(Press and hold to drag)</span></Typography>
                      <StatusText status={singleLegal?.customerExperienceSection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.customerExperienceSection?.status &&
                      <>
                        <Typography variant='h4' className='text-center mb-4' fontWeight="semibold">{singleLegal?.customerExperienceSection?.pageTitle} </Typography>
                        <DragDropContext onDragEnd={(result) => onDragEnd(result, "customerExperienceSection")}>
                          <Droppable droppableId="customerExperienceSection">
                            {(provided) => (
                              <Grid
                                container
                                alignItems="center"
                                spacing={{ xs: 3, md: 4 }}
                                mb={1}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={12}
                                  className="order-change-con"
                                >
                                  {dragSection?.customerExperienceSection?.map((data, index) => (
                                    <Draggable key={data._id} draggableId={data._id} index={index}>
                                      {(provided) => (
                                        <Card
                                          sx={{
                                            p: { xs: 2, md: 3 },
                                            borderRadius: 2.5,
                                            boxShadow: 'none',
                                            backgroundColor: "#F5F5FF",
                                            marginBottom: "25px"
                                          }}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                        // {...provided.dragHandleProps}
                                        >
                                          <span  {...provided.dragHandleProps} style={{ position: "absolute", top: "10px", right: "10px", zIndex: "1", width: "30px", height: "30px", color: "#656575" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                              <path d="M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"></path>
                                            </svg>
                                          </span>
                                          <Grid container alignItems="center" spacing={3} className="order-change-inner">
                                            <Grid item xs={12} md={6}>
                                              <Typography variant='body2' color={grey[600]} mb={1}>Image</Typography>
                                              <Stack direction="row" spacing={1.25}>
                                                <img
                                                  style={{
                                                    borderRadius: '20px',
                                                    width: '430px',
                                                    height: '320px',
                                                    objectFit: 'cover',
                                                  }}
                                                  src={data?.image?.url || defaultProductImage}
                                                  alt="No Image Found"
                                                />
                                              </Stack>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                              <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                  <Typography variant='body2' color={grey[600]} mb={1}>Title(H3)</Typography>
                                                  <Typography variant='h5' fontWeight="medium">{data?.title || "-"}</Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                  <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                                                  <Typography
                                                    variant="h5"
                                                    fontWeight="medium"
                                                    dangerouslySetInnerHTML={{
                                                      __html: data?.description || "-",
                                                    }}
                                                  />
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Card>
                                      )}
                                    </Draggable>
                                  ))}
                                </Grid>
                                {provided.placeholder}
                              </Grid>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                    }


                  </Card>

                  {/***************** Testimonials *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">{'Testimonials'}  <span className='drag_drop'>(Press and hold to drag)</span></Typography>
                      <StatusText status={singleLegal?.testimonialsSection
                        ?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.testimonialsSection?.status &&
                      <>
                        <Typography variant='h4' className='text-center mb-4' fontWeight="semibold">{singleLegal?.testimonialsSection?.pageTitle}</Typography>

                        <DragDropContext onDragEnd={(result) => onDragEnd(result, "testimonialsSection")}>
                          <Droppable droppableId="droppable-testimonials">
                            {(provided) => (
                              <Grid
                                container
                                alignItems="unset"
                                spacing={{ xs: 3, md: 4 }}
                                mb={1}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {dragSection?.testimonialsSection?.map((data, index) => (
                                  <Draggable key={data._id} draggableId={data._id} index={index}>
                                    {(provided) => (
                                      <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                      // {...provided.dragHandleProps}
                                      >
                                        <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none', backgroundColor: "#F5F5FF" }} style={{ height: "100%" }}>
                                          <span {...provided.dragHandleProps} style={{ position: "absolute", top: "10px", right: "10px", zIndex: "1", width: "30px", height: "30px", color: "#656575" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                              <path d="M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"></path>
                                            </svg>
                                          </span>
                                          <Grid container alignItems="center" spacing={{ xs: 2, md: 3 }}>
                                            <Grid item xs={12}>
                                              <Typography variant='body2' color={grey[600]} mb={1}>Image</Typography>
                                              <Stack direction="row" spacing={1.25}>
                                                <img style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover' }}
                                                  src={data?.image?.url || defaultProductImage} alt="Employee" />
                                              </Stack>
                                            </Grid>

                                            <Grid item xs={12}>
                                              <Grid container alignItems="center" spacing={3}>
                                                <Grid item xs={12} md={6}>
                                                  <Typography variant='body2' color={grey[600]} mb={1}>Employee Name</Typography>
                                                  <Typography variant='h5' fontWeight="medium">{data?.name || "-"}</Typography>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <Typography variant='body2' color={grey[600]} mb={1}>Employee Role</Typography>
                                                  <Typography variant='h5' fontWeight="medium">{data?.role || "-"}</Typography>
                                                </Grid>
                                              </Grid>
                                            </Grid>

                                            <Grid item xs={12}>
                                              <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                                              <Typography variant="h5" fontWeight="medium" dangerouslySetInnerHTML={{ __html: data?.description || "-" }} />
                                            </Grid>
                                          </Grid>
                                        </Card>
                                      </Grid>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </Grid>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                    }

                  </Card>

                  {/***************** Job Opening *****************/}
                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">{'Available Positions'}  <span className='drag_drop'>(Press and hold to drag)</span></Typography>
                      <StatusText status={singleLegal?.jobOpeningsSection?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.jobOpeningsSection?.status &&
                      <>
                        <Typography variant='h4' className='text-center mb-4' fontWeight="semibold">{singleLegal?.jobOpeningsSection?.pageTitle}  </Typography>
                        <DragDropContext onDragEnd={(result) => onDragEnd(result, "jobOpeningsSection")}>
                          <Droppable droppableId="droppable-job-openings">
                            {(provided) => (
                              <Grid
                                container
                                alignItems="center"
                                spacing={{ xs: 3, md: 4 }}
                                mb={1}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  md={12}
                                  className="order-change-con"
                                >
                                  {dragSection?.jobOpeningsSection?.map((data, index) => (
                                    <Draggable key={data._id} draggableId={data._id} index={index}>
                                      {(provided) => (
                                        <Card
                                          sx={{
                                            p: { xs: 2, md: 3 },
                                            borderRadius: 2.5,
                                            boxShadow: "none",
                                            backgroundColor: "#F5F5FF",
                                            marginBottom: "25px"
                                          }}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                        // {...provided.dragHandleProps}
                                        >
                                          <span  {...provided.dragHandleProps} style={{ position: "absolute", top: "10px", right: "10px", zIndex: "1", width: "30px", height: "30px", color: "#656575" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                                              <path d="M8.5 7C9.32843 7 10 6.32843 10 5.5C10 4.67157 9.32843 4 8.5 4C7.67157 4 7 4.67157 7 5.5C7 6.32843 7.67157 7 8.5 7ZM8.5 13.5C9.32843 13.5 10 12.8284 10 12C10 11.1716 9.32843 10.5 8.5 10.5C7.67157 10.5 7 11.1716 7 12C7 12.8284 7.67157 13.5 8.5 13.5ZM10 18.5C10 19.3284 9.32843 20 8.5 20C7.67157 20 7 19.3284 7 18.5C7 17.6716 7.67157 17 8.5 17C9.32843 17 10 17.6716 10 18.5ZM15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 6.32843 14.6716 7 15.5 7ZM17 12C17 12.8284 16.3284 13.5 15.5 13.5C14.6716 13.5 14 12.8284 14 12C14 11.1716 14.6716 10.5 15.5 10.5C16.3284 10.5 17 11.1716 17 12ZM15.5 20C16.3284 20 17 19.3284 17 18.5C17 17.6716 16.3284 17 15.5 17C14.6716 17 14 17.6716 14 18.5C14 19.3284 14.6716 20 15.5 20Z"></path>
                                            </svg>
                                          </span>
                                          <Grid container alignItems="center" spacing={3} className="order-change-inner">
                                            <Grid item xs={12} md={6}>
                                              <Typography variant="body2" color={grey[600]} mb={1}>Image</Typography>
                                              <Stack direction="row" spacing={1.25}>
                                                <img
                                                  style={{
                                                    borderRadius: "20px",
                                                    width: '430px',
                                                    height: '320px',
                                                    objectFit: "cover",
                                                  }}
                                                  src={data?.image?.url || defaultProductImage}
                                                  alt="No Image Found"
                                                />
                                              </Stack>
                                            </Grid>

                                            <Grid item xs={12} md={6}>
                                              <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                  <Typography variant="body2" color={grey[600]} mb={1}>
                                                    Position Name
                                                  </Typography>
                                                  <Typography variant="h5" fontWeight="medium">
                                                    {data?.title || "-"}
                                                  </Typography>
                                                </Grid>

                                                <Grid item xs={12}>
                                                  <Typography variant="body2" color={grey[600]} mb={1}>
                                                    Description
                                                  </Typography>
                                                  <Typography
                                                    variant="h5"
                                                    fontWeight="medium"
                                                    dangerouslySetInnerHTML={{
                                                      __html: data?.description || "-",
                                                    }}
                                                  />
                                                </Grid>

                                                <Grid item xs={12}>
                                                  <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                      <Typography variant="body2" color={grey[600]} mb={1}>
                                                        CTA
                                                      </Typography>
                                                      <Typography variant="h5" fontWeight="medium">
                                                        {data?.cta ? (
                                                          data?.cta
                                                        ) : (
                                                          "-"
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                      <Typography variant="body2" color={grey[600]} mb={1}>
                                                        CTA Link
                                                      </Typography>
                                                      <Typography variant="h5" fontWeight="medium">
                                                        {data?.cta ? (
                                                          <a
                                                            href={data?.url}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="cta-link-btn"
                                                          >
                                                            {data?.url}
                                                          </a>
                                                        ) : (
                                                          "-"
                                                        )}
                                                      </Typography>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        </Card>
                                      )}
                                    </Draggable>
                                  ))}
                                </Grid>
                                {provided.placeholder}
                              </Grid>
                            )}
                          </Droppable>
                        </DragDropContext>
                        <a href={singleLegal?.jobOpeningsSection?.link} target="_blank" rel="noopener noreferrer" className='link_opening'>
                          <MDButton
                            className="button_opning"
                            type="button"
                            color="primary"
                            size="medium"
                            variant="outlined"
                            sx={{ minWidth: "180px" }}
                          >
                            Browse All Openings
                          </MDButton>
                        </a>
                      </>
                    }

                  </Card>

                  {/***************** FAQ *****************/}

                  <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                      <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                      <StatusText status={singleLegal?.faq?.status ? "active" : "inactive"} />
                    </Stack>
                    {
                      singleLegal?.faq?.status &&
                      <>
                        {
                          singleLegal?.faq?.section?.length !== 0 ?

                            <Grid container alignItems="center">
                              {
                                singleLegal?.faq?.section?.map((data) => {
                                  return (
                                    <Grid item xs={12} mb={2} key={data.answer}>
                                      <Typography
                                        variant="h5"
                                        fontWeight="medium"
                                        dangerouslySetInnerHTML={{
                                          __html: data?.question || "-",
                                        }}
                                      />
                                      <Typography
                                        variant="body2"
                                        color={grey[600]}
                                        dangerouslySetInnerHTML={{
                                          __html: data?.answer || "-",
                                        }}
                                      />
                                    </Grid>
                                  )
                                })
                              }
                            </Grid>
                            : <NoDataFound />
                        }
                      </>
                    }
                  </Card>
                </Box>
            }
          </>
      }
    </>
  )
}

export default CareerDetail
